import { v4 as uuidv4 } from 'uuid';
import { setGtmData } from '../GTM';
import { CHANNEL_ID_TYPES } from '../constants/common';

export const convertArrayOfObjectToObject = (arrayOfObjects: Array<object>, keyName: string) => {
  let detailsObject = {};

  arrayOfObjects &&
    arrayOfObjects.map((objectData, index) => {
      detailsObject[objectData[keyName]] = { ...objectData };
    });

  return detailsObject;
};

export const formatValueForDropDown = (value: string) => {
  return { label: value, value: value };
};

export const getUniqueReferenceNumber = () => {
  return uuidv4();
};

// For past transaction page get color of the transaction status
export const getTransactionStatusMessageColor = (transactionStatus: string) => {
  switch (transactionStatus) {
    case 'Inprogress':
      return '#6D6E71';
    case 'Success':
      return '#59aa00';
    case 'Cancelled':
      return '#FF0303';
    case 'Failed':
      return '#FF0303';
    case 'Rejected':
      return '#FF0303';
    default:
      return '#6D6E71';
  }
};
// For Cart page get color of the transaction status
export const getCartTransactionStatusMessageColor = (transactionStatus: string) => {
  switch (transactionStatus) {
    case 'Inprogress':
      return '#59aa00';
    case 'Success':
      return '#59aa00';
    case 'Cancelled':
      return '#FF0303';
    case 'Failed':
      return '#FF0303';
    case 'Rejected':
      return '#FF0303';
    default:
      return '#6D6E71';
  }
};

export const getDomain = () => {
  const domain = process.env.DOMAIN;
  return domain === 'undefined' ? undefined : domain;
};

export const getCookiesOptions = () => {
  let expires = new Date();
  expires.setTime(expires.getTime() + 30 * 60 * 1000); // expire in 30 minutes
  return {
    path: '/',
    domain: getDomain(),
    expires,
  };
};

export const replaceEmptySpaceWithHyphen = (word: string, lowercase?: boolean) => {
  // Replace empty space with "-". Ex: "multi cap" becomes "multi-cap"
  if (word) {
    if (lowercase) {
      return word.toLowerCase().replace(/\s/g, '-');
    } else {
      return word.replace(/\s/g, '-');
    }
  }
};

export const getCookie = (cname) => {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export const setChannelName = (channelId: string) => {
  switch (channelId) {
    case CHANNEL_ID_TYPES.EBNKG:
      setGtmData('cd24', 'internet-banking');
      break;
    case CHANNEL_ID_TYPES.MBK:
      setGtmData('cd24', 'mobile-app');
      break;
    case CHANNEL_ID_TYPES.PFM_IB:
      setGtmData('cd24', 'website');
      break;
    case CHANNEL_ID_TYPES.PFM_MPIN:
      setGtmData('cd24', 'website');
    default:
      break;
  }
};

// Whether to append ? or & in the url while passing query params to the URL
export const getQueryParamSymbol = (url: string) => {
  if (url) {
    return url.includes('?') ? '&' : '?';
  }
};

export const toFirstLetterUpperCase = (message: string) => {
  return message[0].toUpperCase() + message.substr(1);
};

export const isBannerActive = (
  startDate: Date | string | undefined | null,
  endDate: Date | string | undefined | null
) => {
  const startingDate = new Date(startDate);
  const endingDate = new Date(endDate);
  const currentDate = new Date();
  return currentDate > startingDate && currentDate < endingDate;
};

// This function is used to convert all caps into camel case refraining the words which has to be in caps e.g ICICI, HDFC.
export const convertToCamelCase = (fundName) => {
  const schemeCapsList = [
    'FOF',
    'IDCW',
    'PSU',
    'CRISIL',
    'AAA',
    'PF',
    'I',
    'ESG',
    'HL',
    'HS',
    'IY',
    'JA',
    'JX',
    'KE',
    'KH',
    'KJ',
    'KO',
    'KP',
    'KW',
    'KX',
    'LU',
    'LV',
    'LX',
    'MA',
    'MD',
    'MK',
    'MP',
    'MQ',
    'MR',
    'MU',
    'MX',
    'MY',
    'NB',
    'ND',
    'NE',
    'NG',
    'NH',
    'NI',
    'NK',
    'NL',
    'NP',
    'NR',
    'NS',
    'NT',
    'NU',
    'NW',
    'NX',
    'OB',
    'OC',
    'OD',
    'OE',
    'OF',
    'OG',
    'OH',
    'OI',
    'OJ',
    'OK',
    'OL',
    'OM',
    'ON',
    'OO',
    'OP',
    'OQ',
    'OR',
    'OS',
    'OT',
    'OV',
    'OW',
    'OX',
    'OY',
    'OZ',
    'PA',
    'PB',
    'PC',
    'PD',
    'PE',
    'PG',
    'PH',
    'PI',
    'PJ',
    'PK',
    'PL',
    'PM',
    'PN',
    'PO',
    'PP',
    'PQ',
    'PR',
    'PS',
    'PT',
    'PU',
    'PV',
    'PW',
    'PX',
    'PY',
    'PZ',
    'QA',
    'QB',
    'QC',
    'QD',
    'QE',
    'QF',
    'QG',
    'QH',
    'QI',
    'QJ',
    'QK',
    'QL',
    'QM',
    'QN',
    'QO',
    'QP',
    'QQ',
    'QR',
    'QS',
    'QT',
    'QU',
    'QV',
    'QW',
    'QX',
    'QY',
    'QZ',
    'RA',
    'RB',
    'RC',
    'RD',
    'RE',
    'RF',
    'RG',
    'RH',
    'RI',
    'RJ',
    'RK',
    'RL',
    'RM',
    'RN',
    'RO',
    'RP',
    'RQ',
    'RR',
    'RS',
    'RT',
    'RU',
    'RV',
    'RW',
    'RX',
    'RY',
    'RZ',
    'SA',
    'SB',
    'SC',
    'SD',
    'SE',
    'SF',
    'SG',
    'SH',
    'SI',
    'SJ',
    'SK',
    'SL',
    'SM',
    'SN',
    'SO',
    'SP',
    'SW',
    'SX',
    'SY',
    'TB',
    'TC',
    'TD',
    'TE',
    'TF',
    'TG',
    'TH',
    'TI',
    'TJ',
    'TK',
    'TL',
    'TM',
    'TN',
    'TO',
    'TP',
    'A',
    'B',
    'II',
    'III',
    'IV',
    'IX',
    'V',
    'VI',
    'VII',
    'VIII',
    'X',
    '1-',
    'MIP',
    'MNC',
    'NASDAQ',
    'SDL',
    '60:40',
    'ETF',
    'AIG',
    'FMP',
    '(1540',
    'CPSE',
    '70:30',
    'ELSS',
    'P',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'NRI',
    '(PSU)',
    'B)',
    'A)',
    'BHARAT',
    'AXA',
    '3M',
    'AAF',
    'Q',
    'R',
    '(400',
    'S',
    'T',
    '(381',
    'U',
    '(386',
    '(371',
    'W',
    'FMP-',
    'AA',
    'AB',
    'AC',
    'AD',
    'AE',
    'AF',
    'AG',
    'AH',
    'AJ',
    'AK',
    'AL',
    'AM',
    'AN',
    'AO',
    'AP',
    'AQ',
    'AR',
    'AS',
    'AT',
    'AU',
    'AV',
    'AW',
    'AY',
    'AZ',
    'BA',
    'BB',
    'BC',
    'BD',
    'BE',
    'BF',
    'BG',
    'BH',
    'BI',
    'BJ',
    'BK',
    'BQ',
    'BR',
    'BS',
    'BT',
    'BU',
    'BV',
    'CA',
    'CB',
    'CC',
    'CD',
    'CE',
    'CF',
    'CG',
    'CH',
    'CI',
    'CJ',
    'CK',
    'CL',
    'CM',
    'CN',
    'CO',
    'CP',
    'CQ',
    'CR',
    'CS',
    'CT',
    'CU',
    'CV',
    'CW',
    'CX',
    'CY',
    'CZ',
    'DA',
    'DB',
    'DC',
    'DD',
    'DE',
    'DF',
    'DG',
    'DH',
    'DI',
    'DJ',
    'DK',
    'DL',
    'DM',
    'DN',
    'DO',
    'DP',
    'DQ',
    'DR',
    'DS',
    'DT',
    'DU',
    'DV',
    'DW',
    'DX',
    'DY',
    'DZ',
    'EA',
    'EB',
    'EC',
    'ED',
    'EE',
    'EF',
    'EG',
    'EH',
    'EI',
    'EJ',
    'EK',
    'EL',
    'EM',
    'EN',
    'EO',
    'EP',
    'EQ',
    'ER',
    'ES',
    'ET',
    'EU',
    'EV',
    'EW',
    'EX',
    'EY',
    'EZ',
    'FA',
    'FB',
    'FC',
    'FD',
    'FE',
    'FF',
    'FG',
    'FH',
    'FI',
    'FJ',
    'FK',
    'FL',
    'FM',
    'FN',
    'FO',
    'FP',
    'FQ',
    'FR',
    'FS',
    'FT',
    'FU',
    'FV',
    'FW',
    'FX',
    'FY',
    'FZ',
    'GA',
    'GB',
    'GC',
    'GD',
    'GE',
    'GF',
    'GG',
    'GH',
    'GI',
    'GJ',
    'GK',
    'GL',
    'GM',
    'GN',
    'GO',
    'GP',
    'GQ',
    'GR',
    'GS',
    'GT',
    'GU',
    'GV',
    'GW',
    'GX',
    'GY',
    'HA',
    'HB',
    'HC',
    'HD',
    'HE',
    'HF',
    'HG',
    'HH',
    'HI',
    'HJ',
    'HK',
    'HM',
    'HN',
    'HO',
    'HP',
    'HQ',
    'HR',
    'HT',
    'HU',
    'HV',
    'HW',
    'HX',
    'HY',
    'HZ',
    'IA',
    'IB',
    'IC',
    'ID',
    'IE',
    'IF',
    'IG',
    'IH',
    'IJ',
    'IK',
    'IL',
    'IM',
    'IN',
    'IO',
    'IP',
    'IQ',
    'IR',
    'IS',
    'IT',
    'IU',
    'IW',
    'IZ',
    'JB',
    'JC',
    'JD',
    'JE',
    'JF',
    'JG',
    'JH',
    'JI',
    'JJ',
    'JK',
    'JL',
    'JM',
    'JN',
    'JO',
    'JP',
    'JQ',
    'JR',
    'JS',
    'JT',
    'JU',
    'JV',
    'JW',
    'JY',
    'JZ',
    'KA',
    'KB',
    'KC',
    'KD',
    'KF',
    'KG',
    'KI',
    'KK',
    'KL',
    'KM',
    'KN',
    'KQ',
    'KR',
    'KS',
    'KT',
    'KU',
    'KV',
    'KY',
    'KZ',
    'LA',
    'LB',
    'LC',
    'LD',
    'LE',
    'LF',
    'LG',
    'LH',
    'LI',
    'LJ',
    'LK',
    'LL',
    'LM',
    'LN',
    'LO',
    'LP',
    'LQ',
    'LR',
    'LS',
    'LT',
    'LW',
    'LY',
    'LZ',
    'MB',
    'MC',
    'ME',
    'MF',
    'MG',
    'MH',
    'MI',
    'MJ',
    'ML',
    'MM',
    'MN',
    'MO',
    'MS',
    'MT',
    'MV',
    'MW',
    'MZ',
    'NA',
    'NC',
    'NF',
    'NJ',
    'NM',
    'NN',
    'NO',
    'NQ',
    'NV',
    'Y',
    '2-',
    '3-',
    'BNP',
    'FTP',
    'BOI',
    'ELS',
    'PGS',
    'DHFL',
    'DSP',
    '10Y',
    'A.C.E.',
    'BFSI',
    '1A',
    '1B',
    '1C',
    '1D',
    '1F',
    '1G',
    '1H',
    '1I',
    '1J',
    '1K',
    '1M',
    '1N',
    '1O',
    '1P',
    '3A',
    '1/2',
    '13M',
    '15M',
    '18M',
    '6M',
    '12M',
    '12.5M',
    'RGESS',
    '54EA',
    '&',
    '(54EA',
    'US',
    'DWS',
    'ASEAN',
    'MSCI',
    'NIFTY',
    'IPO',
    '(13',
    '2A',
    '2B',
    'FMCG',
    'U.S.',
    'XII',
    'XVI',
    'XVII',
    'BSE',
    'NSE',
    '(60',
    '(36',
    '(370',
    'XIII',
    'XIV',
    'XV',
    'GIC',
    'CNX',
    'HDFC',
    '36M',
    '100%',
    '50%',
    '(1)',
    'FIP',
    '(2)',
    '2003(1)',
    '2003(2)',
    '(3)',
    '(4)',
    '(5)',
    'XX',
    'XVIII',
    'JULY',
    'XI',
    '14M',
    '17M',
    'XIX',
    '24M',
    '25M',
    '26M',
    'XXI',
    'HIF',
    'III-D',
    'III-G',
    'V-D',
    'V-G',
    'VI-D',
    'VI-G',
    'STP',
    'NIFTY50',
    'HSBC',
    'IX-',
    'ICICI',
    '(FOF)',
    'AEP',
    '1Y',
    '2Y',
    'Z',
    'XXV',
    '(P.H.D)',
    '40:60',
    'R.I.G.H.T.',
    'S&P',
    'IDBI',
    '2013)',
    '2012)',
    '2014)',
    '2011)',
    'IDFC',
    'YS',
    '11-',
    'GDP',
    '(50-50)',
    '(ELSS)',
    'IIFL',
    'ING',
    'C.U.B',
    'XXII',
    'XXIII',
    'XXIX',
    'XXVI',
    'XXVIII',
    'XXX',
    'XXXI',
    'XXXII',
    'XXXIV',
    'XXXIX',
    'XXXV',
    'XXXVI',
    'XXXVII',
    'XXXVIII',
    '15%',
    '30%',
    'LION',
    'A1',
    'A2',
    'A3',
    'ITI',
    'FMF-',
    'Q2',
    'Q3',
    'Q4',
    'Q5',
    'Q1',
    'XXIV',
    'QSA3',
    'QSA4',
    'QSB3',
    'QSC',
    'QSE',
    'QSG',
    'SA2',
    'SA5',
    'SB2',
    'SF5',
    'SF6',
    'SG4',
    'SG5',
    'S01',
    'YSW',
    'EEMEA',
    'FMP(1)',
    'FMP(2)',
    'FMP(3)',
    '(8)',
    '16M',
    '19M',
    'XXVII',
    'FMP(6)',
    'FMP(7)',
    'REIT',
    'II-',
    'L&T',
    '5M',
    'III)',
    '(410',
    '(12',
    'IV)',
    'LIC',
    'ONE',
    'SIX',
    'ULIS',
    'TECH',
    'NYSE',
    'FANG+',
    'EAFE',
    'XLI',
    'XLII',
    'XLIII',
    'XXXIII',
    'XXXX',
    'PGIM',
    'AI',
    'AX',
    'I-NIT',
    '(FMP',
    '3)-91',
    '6)-371',
    'PNB',
    'A4',
    'B1',
    'B10',
    'B11',
    'B12',
    'B13',
    'B14',
    'B15',
    'B16',
    'B17',
    'B2',
    'B23',
    'B3',
    'B5',
    'B9',
    'SEP',
    'R.E.A.L.',
    'SBI',
    '50:50',
    'EDGE',
    'MDFS',
    'MDFS-180',
    'MDFS-60',
    'SDFS',
    '07)',
    'SUN',
    '1-3',
    '1-5',
    '(90',
    'BL',
    'BM',
    'BN',
    'BO',
    'BP',
    'GZ',
    'TOP',
    'RIP',
    'SHIP',
    'P/E',
    '(IDCW',
    '5%)',
    '10%)',
    '04)',
    '(18',
    '[371',
    'C2',
    'C3',
    'SIP',
    'FHF',
    'TRUSTMF',
    'KBC',
    'UTI',
    '17022020)',
    '(UTI',
    'CCF)',
    '06032020)',
    '07072020)',
    '13092019)',
    '(15',
    '(14',
    '(24',
    '(20',
    'FTI',
    'G-SEC',
    '1(90',
    '(91',
    '(251',
    '(96',
    '(140',
    '(93',
    '(181',
    '1(91',
    'II(90',
    'III(90',
    'IV(90',
    'FEB',
    'WOC',
  ];
  //Convert the fundName into Array
  const fundNameArray = fundName?.split(' ');
  // Logic used: we are selecting the words which are not present in schemeCapsList and then converting them to Camel Case
  const schemeNameInCamelCaseFormat = fundNameArray
    ?.map((value) =>
      schemeCapsList.indexOf(value) === -1 ? value[0].toUpperCase() + value.slice(1).toLowerCase() : value
    )
    .join(' ');
  return schemeNameInCamelCaseFormat;
};

export const addSpaceAfterComma = (amcName) => {
  const withSpaceAfterComma = amcName.split(',').join(', ');
  return withSpaceAfterComma;
};

export const removeExtraSpace = (amcName) => {
  const withoutExtraSpace = amcName.replace(/\s+/g, ' ');
  return withoutExtraSpace;
};

// Utility function to check if user navigator agent/platform is iOS or iPad
// returns true is user is on an iOS Device (iPhone or iPad)
export const checkNavigatorAgentisiOS = () => {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}